import { Box } from "@mui/material";
import React from "react";
import SearchScenario from "./SearchScenario";
import SelectScenario from "./SelectScenario";
import ScenarioInfoForm from "./ScenarioInfoForm";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import {
	getAllEnums,
	getCustGrpRef,
	getScSTQ,
	getTrustLevel,
} from "./editScenarioNewSlice";
import SkuPgSearchForm from "./SkuPgSearchForm";
import SkuPgSearchResult from "./SkuPgSearchResult";
import CustomerCgSearchForm from "./CustomerCgSearchForm";
import CustomerCgSearchResult from "./CustomerCgSearchResult";
import DefineLinkDataSources from "./DefineLinkDataSources";
import DefineScenarioSettings from "./DefineScenarioSettings";
import DefaultSafetyMargin from "./DefaultSafetyMargin";
import CustomerBdMethod from "./CustomerBdMethod";
import Summary from "./Summary";
import MessageForEdit from "./MessageForEdit";
import { setState } from "./editScenarioNewSlice";
import { getCriticalityList, setState as setStateCreate } from "../scenarioSetupNewSlice";
import PredictionMethod from "./PredictionMethod";
import AuthorizedDeviation from "./AuthorizedDeviation";
import CollapseSection from "../../../../components/ui/CollapseSection";
import MessageForCreate from "../Create/MessageForCreate";
import ScenarioValidationPopUp from "./ScenarioValidationPopup";
import ScenarioValidationPopUpCreate from "../Create/ScenarioValidationPopupCreate";

export default function EditScenario() {
	const dispatch = useDispatch();
	const states = useSelector((store) => store.editScenarioNew);
	const { periodTypes, customerTypes, trustLevels, scenarioSTQ,predictionMethodPeriodList,previousYearPeriodList,DefaultInitialForecast, SafetyMargin, selectedcustomerTypes,criticalityList,
		section_SKU, section_Customer, section_Datasources, section_Scenario_Settings} = states;

	useEffect(() => {
		clearData();
		if (periodTypes.length === 0) {
			dispatch(getAllEnums());
		}
		if (customerTypes.length === 0) {
			dispatch(getCustGrpRef());
		}
		if (trustLevels.length === 0) {
			dispatch(getTrustLevel());
		}
		if (scenarioSTQ.length === 0) {
			dispatch(getScSTQ());
		}
		if (criticalityList.length === 0) {
			dispatch(getCriticalityList());
		}
	}, []);
	const clearData = () =>{
		dispatch(setState("isLoading", false));
		dispatch(setState("sku_PG_Name", ""));
		dispatch(setState("productGroups", []));
		dispatch(setState("selectedPGs", []));
		dispatch(setState("selectedcustomerTypes", []));
		dispatch(setState("selectedCustType", ""));
		dispatch(setState("selectedCTCode", ""));
		dispatch(setState("selectedCL", ""));
		dispatch(setState("selectedCLID", ""));
		dispatch(setState("breakDowns", []));
		dispatch(setState("selectedBD", ""));
		dispatch(setState("breakDownTypes", []));
		dispatch(setState("selectedBDT", ""));
		dispatch(setState("selectedTL", "All"));
		dispatch(setState("selectedTLID", 0));
		dispatch(setState("customerName", ""));
		dispatch(setState("custsCGs", []));
		dispatch(setState("selectedCustsCGs", []));
		dispatch(setState("selectedDSs", []));
		dispatch(setState("selectedPDS", ""));
		dispatch(setState("selectedSKUBDM", ""));
		dispatch(setState("selectedScSTQ", "Disabled"));
		dispatch(setState("selectedScUB", "Disabled"));
    	dispatch(setState("selectedScModifySTQ", "Disabled"));
		dispatch(setState("selectedPG_SKU_ADSs",""));
		dispatch(setState("selectedPG_SKU_ADSsID", ""));
		dispatch(setState("DSAData", []));
		dispatch(setState("scDSA", []));
		dispatch(setState("scDSACopy", []));
		dispatch(setState("DSAIdString", ""));
		dispatch(setState("DSAIdStringPrev", ""));
		dispatch(setState("skuBreakdown", ""));
		dispatch(setState("customerBreakdownType", "Scenario SKUs"));
		dispatch(setState("customerBreakdown", "Internal 3 months"));
		dispatch(setState("MarketShareTimePeriod", ""));
		dispatch(setState("PreviousMarketShareTimePeriod", ""));
		dispatch(setState("scenarioName", ""));
		// api payload for scenario
		dispatch(setState("primaryDataSourceID", ""));
		dispatch(setState("minimumQuota", ""));
		dispatch(setState("comments", ""));
		dispatch(setState("lstScenarioCustomers", ""));
		dispatch(setState("lstScenarioCustomerGroups", ""));
		dispatch(setState("lstScenarioSKUs", ""));
		dispatch(setState("lstScenarioProducts", ""));
		dispatch(setState("scenarioDataSourceAlignment", []));
		dispatch(setState("scenarioStatus", ""));
		dispatch(setState("editScName", ""));
		dispatch(setState("editScenarioList", []));
		dispatch(setState("editScID", ""));
		dispatch(setState("editScDetails", null));
		dispatch(setState("message", ""));
		dispatch(setState("severity", ""));
		dispatch(setState("messageOpen", ""));
		dispatch(setState("selectedLinearTrend", predictionMethodPeriodList[0]?.name));
		dispatch(setState("selectedRunRate", predictionMethodPeriodList[0]?.name));
		dispatch(setState("selectedConsensus", predictionMethodPeriodList[0]?.name));
		dispatch(setState("selectedPreviousYear", previousYearPeriodList[0]?.name));
		dispatch(setState("selectedDefaultInitialForecast", DefaultInitialForecast[1]?.name));
		dispatch(setState("editScDSAData", []));
		dispatch(setState("localForecastAlignment", []));
		dispatch(setState("periodType", ""));
		dispatch(setState("emailNotification", false));
		dispatch(setState("criticalityId", ""));
		dispatch(setState("SafetyMargin",[]));
		//dispatch(setState("SafetyMargin", [{type: "Customer Group", safetyMargin: '', typeCode: "CustomerGroup"}],));
		dispatch(setState("selectedReferenceSKU", []));
		dispatch(setState("previousSelectedReferenceSKU", []));
		dispatch(setState("marketShareComparisonList", []));
		dispatch(setState("previousMarketShareComparisonList", []));
		dispatch(setState("selectedRows", []));
		dispatch(setState("marketShareGraphData", []));
		dispatch(setState("previousMarketShareGraphData", []));
		dispatch(setState("manually_defineMSList", []));
		dispatch(setState("quotaDeviationPercentage", 0));
		dispatch(setState("modificationDeviationPercentage", 0));
		dispatch(setState("scenarioExternalDataSource", []));
		dispatch(setState("scenarioExternalDataSourceSKU", []));
		dispatch(setState("refList",''));
		dispatch(setState("selectedCCID", 0));
		dispatch(setState("selectedCustCat", "All"));
		dispatch(setState("selectedCountry", ""));
		dispatch(setState("countryID", ""));
		dispatch(setState("createToDate", null));
		dispatch(setState("createFromDate", null));
		dispatch(setState("openScenarioPopUp", false));
		dispatch(setState("errorMessage", ""));
		dispatch(setState("errorList", []));
		//dispatch(setStateCreate("message", ""));
		//dispatch(setStateCreate("severity", ""));
		//dispatch(setStateCreate("messageOpen", false));
		dispatch(setState("section_Scenario_Parameteres", false));
		dispatch(setState("section_SKU", false));
		dispatch(setState("section_Customer", false));
		dispatch(setState("section_Datasources", false));
		dispatch(setState("section_Scenario_Settings", false));
		dispatch(setState("is_Refresh", true));
		dispatch(setState("isCustomerChanged", false));
	};

	return (
		<Box>
			<Box>
				<MessageForEdit />
				<MessageForCreate/>
			</Box>
			<ScenarioValidationPopUp />
			<ScenarioValidationPopUpCreate />
			<SearchScenario />
			<SelectScenario />
			<ScenarioInfoForm />
			<CollapseSection title="Select SKUs/Product Groups" isError = {section_SKU}>
				<SkuPgSearchForm />
				<SkuPgSearchResult />
			</CollapseSection>
			<CollapseSection title="Select Customer Groups/Customers" isError = {section_Customer}>
				<CustomerCgSearchForm />
				<CustomerCgSearchResult />
			</CollapseSection>	
			<CollapseSection title="Define and Link Data Sources" isError = {section_Datasources}>
				<DefineLinkDataSources />
			</CollapseSection>
			<CollapseSection title="Define Scenario Settings" isError = {section_Scenario_Settings}>
				<DefineScenarioSettings />
				<DefaultSafetyMargin />
				<CustomerBdMethod />
				<PredictionMethod />
				<AuthorizedDeviation />
			</CollapseSection>
			<Summary />
		</Box>
	);
}
